'use client'

import styled from 'styled-components'

import { Button, isUppercase } from '@syconium/little-miss-figgy'
import { TextLink } from '@syconium/little-miss-figgy/dist/components/TextLink'
import {
  TypeStyle,
  TypeStyleCssFunctionProps,
} from '@syconium/little-miss-figgy/dist/components/TypeStyle'

import { gql } from '../../../../../__generated__/graphql/catalog'
import { StyledLinkFragmentFragment } from '../../../../../__generated__/graphql/catalog/graphql'
import { useStaticAmplitudeTracking } from '../../../../_hooks/useStaticTracking'
import { useTrackingLocation } from '../../../../_providers/TrackingLocationProvider.client'
import { NextLink } from '../../../navigation/NextLink'

export const styledLinkQueryFragment = gql(`
  fragment StyledLinkFragment on StyledLink {
    __typename  
    id
    text
    url
    linkStyle
  }
`)

export type ContentfulStyledLinkProps = StyledLinkFragmentFragment &
  TypeStyleCssFunctionProps & {
    className?: string
  }

// Sized by padding per the design, rather than the lmf Button's fixed min-height.
const ButtonLink = styled(Button)`
  min-height: unset;
  padding: 16px 32px;
`

export const ContentfulStyledLink = styled(
  ({ className, url, text, linkStyle }: ContentfulStyledLinkProps) => {
    const { sectionNumber } = useTrackingLocation()
    const { trackStaticAmplitudeEvent } = useStaticAmplitudeTracking()
    // Styled links also render inside Contentful rich text (e.g. PDP detail tabs, disclaimers);
    // only track the ones inside a Contentful page section.
    const onClick =
      sectionNumber !== undefined
        ? () => trackStaticAmplitudeEvent({ modifiedElement: 'Module Link', href: url })
        : undefined
    return (
      <>
        {linkStyle === 'link' && (
          <TextLink
            as={NextLink}
            className={className}
            href={url}
            variant='underline'
            onClick={onClick}
          >
            {text}
          </TextLink>
        )}
        {linkStyle === 'button' && (
          <ButtonLink
            forwardedAs={NextLink}
            href={url}
            className={className}
            allCaps={isUppercase(text)}
            onClick={onClick}
          >
            {text}
          </ButtonLink>
        )}
      </>
    )
  }
)`
  ${o => (o.linkStyle === 'link' ? TypeStyle.css.headlineExtraExtraSmall : null)}
`
